"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FooterComponent = /*#__PURE__*/function () {
  function FooterComponent() {
    _classCallCheck(this, FooterComponent);

    this._footer = $('footer');
    this.init();
  }

  _createClass(FooterComponent, [{
    key: "init",
    value: function init() {
      var _this = this;

      var mainContainer = $('#main');
      this.containerWidth = this.getContainerWidth(); // init

      new ResizeSensor(mainContainer[0], function (e) {
        _this.updateFooter();
      });
      this.updateFooter();
    }
  }, {
    key: "updateFooter",
    value: function updateFooter() {
      var windowHeight = $(window).outerHeight(true);
      var mainHeight = $("#main").outerHeight(true);
      var headerHeight = $("header").outerHeight(true);

      var footerHeight = this._footer.outerHeight(true);

      if (mainHeight + headerHeight + footerHeight > windowHeight) {
        this._footer.removeClass('fixed');
      } else {
        this._footer.addClass('fixed');
      }
    }
  }, {
    key: "getContainerWidth",
    value: function getContainerWidth() {
      return $("#main .container").width();
    }
  }]);

  return FooterComponent;
}();